import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Massachusetts = () => {
  return (
    <StatePropertyTaxPage
      stateName="Massachusetts"
      processDescription="Abatement applications must be filed with the Assessor within 30 days of the mailing of the actual tax bill (Q3)."
      noticeOfValueMailed="October"
      noticeOfValueMailedDateExplanation="Value appears on the actual (3rd quarter) bill often mailed in October"
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="All property is assessed based on its value as of January 1 prior to the tax year (Massachusetts General Laws Chapter 59, § 2A). This assessment date captures the property's value at the beginning of the year preceding the tax year."
      deadlineExplanation="Property owners have a 30-day deadline after actual Q3 bill issuance to file abatement applications. This typically falls around October 31, but the exact date depends on when the actual tax bill is mailed."
    />
  );
};

export default Massachusetts;